import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'recommendationCheckBox', 'endPageAttributes',
    'effectivenessReviewAttributesCheckBox', 'effectivenessReviewAttributes',
  ];

  connect() {
    this.toggleEndPageFields();
    this.toggleEffectivenessReviewAttributes();
  }

  toggleEndPageFields() {
    const recommendationIsChecked = this.recommendationCheckBoxTarget.querySelector('input').value === 'true';
    this.endPageAttributesTarget.hidden = recommendationIsChecked;
  }

  toggleEffectivenessReviewAttributes() {
    const effectivenessReviewAttributesIsChecked = this.effectivenessReviewAttributesCheckBoxTarget.querySelector('input').value === 'true';
    this.effectivenessReviewAttributesTarget.hidden = !effectivenessReviewAttributesIsChecked;
  }
}
